/** Shared Niko Vibe brand tokens - aligned with homepage hero */

/** Lightweight WebP wordmark (same 507×218 as source). JPEG kept for PDF/QR/OG. */
export const BRAND_LOGO_SRC = '/images/niko_vibe_logo.webp';
export const BRAND_LOGO_FALLBACK_SRC = '/images/niko_vibe_logo.jpg';
export const BRAND_LOGO_WIDTH = 507;
export const BRAND_LOGO_HEIGHT = 218;
export const BRAND_NAME = 'Niko Vibe';

export const HERO_GRADIENT =
  'linear-gradient(135deg, rgba(209, 91, 45, 0.95) 0%, rgba(242, 201, 76, 0.9) 100%)';

export const HERO_GRADIENT_SOFT =
  'linear-gradient(135deg, rgba(209, 91, 45, 0.08) 0%, rgba(242, 201, 76, 0.12) 100%)';

/** Subtle outlined / ghost action - use instead of solid orange blocks */
export const btnSubtle =
  'inline-flex items-center justify-center gap-1.5 text-sm font-medium text-orange-700 border border-orange-200 bg-white hover:bg-orange-50 hover:border-orange-300 rounded-md px-4 py-2 transition-colors';

export const btnSubtleGhost =
  'inline-flex items-center gap-1 text-xs font-medium text-gray-500 group-hover:text-orange-600 transition-colors';
